class WebSocketService {
  static instance = null;

  callbacks = {};
  socketRef = null;

  static getInstance() {
    if (!WebSocketService.instance) {
      WebSocketService.instance = new WebSocketService();
    }
    return WebSocketService.instance;
  }

  constructor() {
    this.socketRef = null;
  }

  connectNotifications(uuid) {
    const path = `${process.env.REACT_APP_API_WEBSOCKET_URL}notifications`;
    this.socketRef = new WebSocket(`${path}?uuid=${uuid}`);
  }

  send(data) {
    this.socketRef.send(data);
  }

  close() {
    this.socketRef.close();
  }
}

const WebSocketInstance = WebSocketService.getInstance();

export default WebSocketInstance;
